<script lang="ts">
  import { Col, FormGroup, Label, Row } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Checked, Default, Disabled, Squarecheckbox } from "../../../../utils/Constant/Constant";
  import SolidCheckbox from "./SolidCheckbox.svelte";
</script>
<Col md="12">
  <Card cardHeaderprops="pb-0" headerTitle={Squarecheckbox}>
    <div slot="contentbody">
      <Row>
        <Col>
          <FormGroup>
            <div class="checkbox checkbox-dark m-squar">
              <input id="inline-sqr-1" type="checkbox">
              <Label class="mt-0" for="inline-sqr-1">{Default}</Label>
            </div>
            <div class="checkbox checkbox-dark m-squar">
              <input id="inline-sqr-2" type="checkbox" disabled>
              <Label for="inline-sqr-2">{Disabled}</Label>
            </div>
            <div class="checkbox checkbox-dark m-squar">
              <input id="inline-sqr-3" type="checkbox" checked>
              <Label for="inline-sqr-3">{Checked}</Label>
            </div>
          </FormGroup>
        </Col>
        <SolidCheckbox />
      </Row>
    </div>
  </Card>
</Col>